import styled from "styled-components";
import { LastLoginDefaultBox } from "./last-login.default.box";

export const LastLoginSICisBox = styled(LastLoginDefaultBox)`
    letter-spacing: 0.4px;
    background-position: -65px -419px;
`;